import { RegionCaptureProfile, SaveProfileDTO } from 'business/models/Models';

export interface fetchImageSettingsProps {
  setCaptureImageSettings: (value: SaveProfileDTO[]) => void;
  setRegionCaptureProfiles: (value: RegionCaptureProfile[]) => void;
  setIsUseAsExperiment: (value: boolean) => void;
  roiId: number;
  showModal: boolean;
}

export interface SelectedOptionProps {
  isEnabled: boolean;
  imageSettingId: number;
  regionCaptureProfiles: RegionCaptureProfile[];
  setRegionCaptureProfiles: (value: RegionCaptureProfile[]) => void;
}

export const tableHeader: {
  accessor: string;
  Header: string;
  className?: string;
}[] = [
  {
    accessor: 'name',
    Header: 'Imaging Settings',
    className: 'img-imageSettings-col',
  },
  {
    accessor: 'isImagingEnabled',
    Header: 'Selected',
    className: 'capture-profile-enable-col',
  },
];
